import { FirebaseDocRefType } from 'firebase/index'
import { BreadType } from 'types/bread'

const fetchBreadsByOrder = async (
  storeRef: FirebaseDocRefType,
  manufacturerRef: FirebaseDocRefType | undefined
): Promise<BreadType[]> => {
  const breadRefs: FirebaseDocRefType[] = []
  const storeBreadQuery =
    typeof manufacturerRef !== 'undefined'
      ? storeRef
          .collection('store_breads')
          .where('manufacturer_ref', '==', manufacturerRef)
          .orderBy('created_at', 'asc')
      : storeRef.collection('store_breads').orderBy('created_at', 'asc')
  // breadsへのrefを取得する
  const snapshots = await storeBreadQuery.get()
  for (let i = 0; i < snapshots.docs.length; i = (i + 1) | 0) {
    const snapshot = snapshots.docs[i]
    const data = snapshot.data()
    if (!data) continue
    if (!('bread_ref' in data)) continue
    breadRefs.push(data.bread_ref)
  }
  // breadsのデータを取得する
  let breads: BreadType[] = []
  const promises = []
  for (let i = 0; i < breadRefs.length; i = (i + 1) | 0) {
    const ref = breadRefs[i]
    promises.push(
      ref
        .get()
        .then((snapshot) => {
          const data = snapshot.data() as BreadType
          if (!data) return
          data.bread_ref = snapshot.ref
          breads.push(data)
        })
        .catch((error) => {
          console.error(error)
        })
    )
  }
  await Promise.all(promises)
  breads = breads.filter((bread) => bread.status !== 'delete')
  breads.sort((a, b) => (a.order < b.order ? -1 : 1))
  return breads
}

export default fetchBreadsByOrder
